import { validateEmail } from "../utils";

const registerValidation = (data) => {
  let errors = {};
  if (!data.firstName) {
    errors.firstName = "First Name is required";
  }
  if (!data.lastName) {
    errors.lastName = "Last Name is required";
  }
  if (!data.email) {
    errors.email = "Email is required";
  }
  if (data.email && !validateEmail(data.email)) {
    errors.email = "Invalid Email";
  }
  if (!data.password) {
    errors.password = "Password is required";
  } else {
    // Password must be at least 8 characters
    if (data.password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
    }
    // Password must contain at least one uppercase letter
    else if (!/[A-Z]/.test(data.password)) {
      errors.password = "Password must contain at least one uppercase letter";
    }
    // Password must contain at least one number
    else if (!/[0-9]/.test(data.password)) {
      errors.password = "Password must contain at least one number";
    }
    // Password must contain at least one special character
    else if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(data.password)) {
      errors.password = "Password must contain at least one special character";
    }
  }

  if (!data.confirmPassword) {
    errors.confirmPassword = "Confirm Password is required";
  }

  if (data.password && data.confirmPassword && data.password !== data.confirmPassword) {
    errors.confirmPassword = "Password and Confirm Password should be same.";
  }
  if (!data.username) {
    errors.username = "Username is required";
  }

  if (!data.phoneNumber) {
    errors.phoneNumber = "Phone Number is required";
  }
  if (data.phoneNumber?.length < 11) {
    errors.phoneNumber = "Please enter valid Phone Number";
  }
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export default registerValidation;
